import {gql} from '@apollo/react-hooks'

const DeleteGameMutation = gql(
`
mutation($id: ID!) {
  deleteGame(id: $id) {
    id
  }
}`
);
export default DeleteGameMutation